import ready from "../utils/ready";
import {
  attachValidation
} from "../components/form";

ready().then(() => {
  attachValidation();
});
